<template>
  <form ref="root" @submit.prevent="onSubmit">
    <VueFocusLock>
      <VueGlobalEvents @keyup.esc="$emit('close')" @click="onClick" />
      <div class="container-fixed nav-search">
        <label for="search">{{ $t('common.searchLabel') }}</label>
        <input id="search" v-model="searchInput" v-focus type="text" class="form-input" name="search" :placeholder="$to('common.search_placeholder')" />
        <VButton type="submit" class="submit btn-default btn-icon">
          <VSvgIcon name="search" variant="outlined" />
          {{ $t('common.searchBtn') }}
        </VButton>
        <button type="button" class="close" :aria-label="$t('common.close')" @click="$emit('close')">
          <VSvgIcon name="cancel" variant="outlined" />
        </button>
      </div>
    </VueFocusLock>
  </form>
</template>

<script>
import { mapState } from 'vuex';
import VueFocusLock from 'vue-focus-lock';
import VButton from '@/components/Button';
import focus from '@/directives/focus';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
export default {
  name: 'NavigationSearch',

  directives: {
    focus,
  },

  components: {
    VSvgIcon,
    VueGlobalEvents: () => import('vue-global-events'),
    VueFocusLock,
    VButton,
  },

  data() {
    return {
      searchInput: '',
    };
  },

  computed: {
    ...mapState('system', ['externalSearchUrl']),
  },

  methods: {
    onClick(event) {
      if (!(this.$refs.root === event.target || this.$refs.root.contains(event.target))) {
        // click outside
        this.$emit('close');
      }
    },

    onSubmit() {
      const url = this.externalSearchUrl + encodeURIComponent(this.searchInput);
      window.open(url, '_blank');
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

.nav-search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 78px;

  label {
    padding-right: 12px;
    white-space: nowrap;
  }

  .submit {
    margin-left: 12px;
  }

  .close {
    margin-left: 24px;
  }
}

@media (max-width: #{$grid-small-max}px) {
  .nav-search {
    display: block;
    height: auto;

    label {
      margin-top: 12px;
    }

    .submit {
      width: 100%;
      margin: 12px 0;
    }

    .close {
      margin-bottom: 12px;
    }
  }
}
</style>
